// Styling related variables
export const SITE_CONTENT_MAX_WIDTH = "1440px";
export const SITE_HEADER_HEIGHT = "69px";
export const SITE_SCROLL_SPACE = "2rem";
export const SITE_SCROLL_MARGIN = `calc(${SITE_HEADER_HEIGHT} + ${SITE_SCROLL_SPACE})`;
// Used to 'bleed' sections together. GettingStarted+Popular
export const HOMEPAGE_SECTION_OVERFLOW_OFFSET = 150;

// Netlify provides an environment variable called CONTEXT which reflects their build context https://docs.netlify.com/site-deploys/overview/#deploy-contexts
// We need to use this to know where the Gatsby site is being run for metrics tracking. Gatsby env variables all need
// start with GATSBY_, so GATSBY_ENVIRONMENT_CONTEXT is just a re-implementation of Netlify's $CONTEXT
export type EnvironmentContext = "production" | "deploy-preview" | "branch-deploy" | "local";
export const ENVIRONMENT_CONTEXT: EnvironmentContext =
    (process.env.GATSBY_ENVIRONMENT_CONTEXT as EnvironmentContext) || "local";

// Version Switcher related variables
export const NPM_FLEX_UI = "https://registry.npmjs.org/@twilio/flex-ui";

// Site Variables
export const SiteMetaDefaults = {
    TITLE: "Flex UI API Reference",
    DESCRIPTION: ""
};
